import IconButton from "@mui/material/IconButton"
import { forwardRef } from "react"

interface CustomIconButtonProps extends React.ComponentPropsWithoutRef<typeof IconButton> {
  children: React.ReactNode;
}
const CustomIconButton = forwardRef<HTMLButtonElement, CustomIconButtonProps>(({children, ...props}, ref) => {
  return (
    <IconButton
      ref={ref}
      color="primary"
      sx={{
        padding: 6,
        backgroundColor: 'primary.main',
        color: 'white',
        '&:hover': { backgroundColor: 'primary.dark' },
      }}
      {...props}
    >
      {children}
    </IconButton>
  )
})

CustomIconButton.displayName = 'CustomIconButton';

export default CustomIconButton;